<app-topnav [llttfPage]="true" [pageName]="pageName"></app-topnav>
<div class="container">
  <div class="content user-mgmt-page" role="main">
    <header class="user-mgmt-page__header">
      <div>
        <h1 class="user-mgmt-page__title">LLTTF Invitation Management</h1>
        <p class="user-mgmt-page__subtitle">Search, filter, and manage Living Life to the Full cohort invitations.</p>
        @if (totalRecords > 0) {
          <div class="user-mgmt-page__meta">
            <span class="user-mgmt-page__count">{{ totalRecords | number }} invitations found</span>
          </div>
        }
      </div>
      <div class="user-mgmt-page__actions">
        @if (showAddButton) {
          <a routerLink="/create-llttf-invitation" class="user-mgmt-page__btn user-mgmt-page__btn--primary">
            <mat-icon>add</mat-icon>
            Create Invitation
          </a>
        }
      </div>
    </header>

    <section class="user-mgmt-page__filters">
      <form (ngSubmit)="search()">
        <div class="user-mgmt-page__filters-grid">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Search</mat-label>
            <mat-icon matPrefix>search</mat-icon>
            <input matInput class="form-control-textbox" name="filterSearch" [(ngModel)]="queryFilter.InvitationSearchKeyword" placeholder="Cohort name" />
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Organization</mat-label>
            <mat-select placeholder="All Organizations" name="filterOrg" [(ngModel)]="queryFilter.OrganizationId">
              <mat-option value="">All Organizations</mat-option>
              @for (org of orgList; track org) {
                <mat-option [value]="org.id">{{ org.organizationName }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Facilitator</mat-label>
            <mat-select placeholder="All Facilitators" name="filterUser" [(ngModel)]="queryFilter.FacilitatorId">
              <mat-option value="0">All Facilitators</mat-option>
              @for (user of LLTTFUsers; track user) {
                <mat-option [value]="user.userDbId">{{ user.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Status</mat-label>
            <mat-select placeholder="All Statuses" name="filtercoursestatus" [(ngModel)]="queryFilter.Status">
              <mat-option value="ALL">All Statuses</mat-option>
              <mat-option value="ACTIVE">Active</mat-option>
              <mat-option value="INACTIVE">All Inactive</mat-option>
              <mat-option value="INACTIVEEXPIRED">Inactive-Expired</mat-option>
              <mat-option value="INACTIVEWITHDRAWN">Inactive-Withdrawn</mat-option>
              <mat-option value="INACTIVEUSED">Inactive-Used</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="user-mgmt-page__filters-actions">
          <button class="user-mgmt-page__btn user-mgmt-page__btn--primary" type="submit" #submitButton>
            <mat-icon>filter_list</mat-icon>
            Apply Filters
          </button>
          <button class="user-mgmt-page__btn user-mgmt-page__btn--secondary" type="button" (click)="resetFilters()">
            <mat-icon>restart_alt</mat-icon>
            Reset
          </button>
        </div>
      </form>
    </section>

    <section class="user-mgmt-page__table-card">
      <ng-container *ngTemplateOutlet="table; context: { data: llttfinvitationslist, headerVisible: true }"></ng-container>
      <mat-paginator
        #paginator
        [length]="totalRecords"
        [pageSize]="25"
        [hidden]="totalRecords === 0"
        [pageSizeOptions]="[10, 25, 50]"
        (page)="handlePageEvent($event)"
        aria-label="Invitation list pagination">
      </mat-paginator>
    </section>
  </div>
</div>

<ng-template #table let-data="data" let-headerVisible="headerVisible">
  <app-no-results #noResults></app-no-results>

  <table mat-table class="fileList primary" [dataSource]="data" [hidden]="data.length === 0">
    <ng-container matColumnDef="col1">
      <th mat-header-cell *matHeaderCellDef>Cohort Name</th>
      <td mat-cell *matCellDef="let result">
        <a [routerLink]="['/view-llttf-invitation', result.id]" class="user-mgmt-page__user-link">{{ result.cohortName }}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="col2">
      <th mat-header-cell *matHeaderCellDef>Organization</th>
      <td mat-cell *matCellDef="let result">{{ result.organization }}</td>
    </ng-container>

    <ng-container matColumnDef="col3">
      <th mat-header-cell *matHeaderCellDef>Current Enrollment</th>
      <td mat-cell *matCellDef="let result">{{ result.currentEnrollment }}</td>
    </ng-container>

    <ng-container matColumnDef="col4">
      <th mat-header-cell *matHeaderCellDef class="w-130">Expiry Date</th>
      <td mat-cell *matCellDef="let result">{{ result.linkExpiryDate }}</td>
    </ng-container>

    <ng-container matColumnDef="col5">
      <th mat-header-cell *matHeaderCellDef>
        Status
        <app-information-popup [information]="information"></app-information-popup>
      </th>
      <td mat-cell *matCellDef="let result">
        <app-status-bubble [status]="result.status" [statusDescription]="result.statusDescription"></app-status-bubble>
      </td>
    </ng-container>

    @if (headerVisible) {
      <tr mat-header-row *matHeaderRowDef="columnsToDisplay" class="tableHeader"></tr>
    }
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
  </table>
</ng-template>

<app-footer></app-footer>
